import connectifService from '../utils/connectifService'
import type { ConnectifProduct } from '../entities'
import { useUserStore } from '~/modules/auth/stores/userStore'

const sendConnectifPageView = () => {
  if (import.meta.client) {
    const userStore = useUserStore()
    const sendEvent = () => {
      const user = userStore.getUserdata
      if (user && user.logged) {
        connectifService.send({
          type: 'page-visit',
          entityInfo: {
            primaryKey: user.mail,
          },
        })
      } else {
        connectifService.send({ type: 'page-visit' })
      }
    }
    sendEvent()
    userStore.$subscribe(() => {
      sendEvent()
    })
  }
}

const sendConnectifProductView = (product: ConnectifProduct) => {
  import.meta.client &&
    connectifService.send({
      type: 'product-visited',
      product,
    })
}

export { sendConnectifPageView, sendConnectifProductView }
